import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Url } from '@wix/da-url';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import type { MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';

export function useEarningsItem(): MenuItem {
  const { t } = useTranslation();
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
  const isMobile = useContext(MobileContext);
  const earningsUrl = Url.studio({ section: 'earnings' });
  return {
    label: t('siteHeader.userMenu.myEarnings'),
    link: Url.buildFromPath(earningsUrl),
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      link_url: Url.buildFromPath(earningsUrl),
      menu_item: isMobile ? 'myEarnings' : 'earnings',
      menu_name: 'profile',
    }),
    tabIndex: isUserMenuOpen || !isMobile ? 0 : -1,
  };
}
